export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;
  static #safeStorage(op) {
    try {
      return op();
    } catch {
      return null;
    }
  }
  static addProduct(productId) {
    let viewedProducts = this.getProducts();
    viewedProducts = viewedProducts.filter((id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);
    this.#safeStorage(() =>
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts)),
    );
  }
  static clearProducts() {
    this.#safeStorage(() => localStorage.removeItem(this.#STORAGE_KEY));
  }
  static getProducts() {
    const stored = this.#safeStorage(() =>
      localStorage.getItem(this.#STORAGE_KEY),
    );
    if (!stored) return [];
    try {
      const parsed = JSON.parse(stored);
      if (!Array.isArray(parsed)) {
        this.clearProducts();
        return [];
      }
      return parsed;
    } catch {
      this.clearProducts();
      return [];
    }
  }
}
